/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

export const referralSources = {"BROWSE":"browse","GENERAL_REFERRAL_PAGE":"general_referral_page","PARTICIPANT_DASHBOARD":"participant_dashboard","PROJECT_APPLY_PAGE":"project_apply_page","PROJECT_APPLY_SUCCESS_PAGE":"project_apply_success_page","PROJECT_DISMISS_PAGE":"project_dismiss_page","PROJECT_LISTING":"project_listing","SESSION_CONFIRMATION_EMAIL":"session_confirmation_email","STAFF_PROJECT_EMAIL":"staff_project_email","STUDIES":"studies","SUGGESTED_STUDY_EMAIL":"suggested_study_email"};
